import { type StoreName } from '@bluebrick/discounts-service-module'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { fetchAll } from '@/features/stores/storesRemoteRepository'
import { sort } from '@/features/stores/storesUtils'
import { type Store } from '@/types'

const useStoresInnerStore = defineStore('storesInner', () => {
	const stores = ref<Store[]>([])
	const storeContainerExpandedState = ref(new Map<StoreName, boolean>())
	const storeForFavouriteSKUs = ref<StoreName | undefined>()

	return {
		stores,
		storeContainerExpandedState,
		storeForFavouriteSKUs
	}
})

export const useStoresStore = defineStore('stores', () => {
	const innerStore = useStoresInnerStore()

	const stores = computed(() => innerStore.stores)
	const storeContainerExpandedState = computed(() => innerStore.storeContainerExpandedState)
	const storeForFavouriteSKUs = computed(() => innerStore.storeForFavouriteSKUs)

	const storeIdToStore = computed(() =>
		stores.value.reduce<Partial<Record<StoreName, Store>>>((result, store) => {
			result[store.id] = store

			return result
		}, {})
	)

	const storeIdToStoreName = computed(() =>
		stores.value.reduce<Partial<Record<StoreName, string>>>((result, store) => {
			result[store.id] = store.displayName

			return result
		}, {})
	)

	async function fetch() {
		const allStores = (await fetchAll()) ?? []

		innerStore.stores = sort(allStores)
	}

	function toggleStoreContainerExpandedState(storeName: StoreName, isExpanded: boolean) {
		innerStore.storeContainerExpandedState.set(storeName, isExpanded)
	}

	function setStoreForFavouriteSKUs(storeName?: StoreName) {
		innerStore.storeForFavouriteSKUs = storeName
	}

	return {
		stores,
		storeContainerExpandedState,
		storeIdToStore,
		storeIdToStoreName,
		storeForFavouriteSKUs,
		fetch,
		toggleStoreContainerExpandedState,
		setStoreForFavouriteSKUs
	}
})
